import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-login-password-field',
  templateUrl: './login-password-field.component.html',
  styleUrls: ['./login-password-field.component.css']
})
export class LoginPasswordFieldComponent {
  @Input() form: FormGroup;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/login/login-form/login-password-field/login-password-field.component.ts